import { mdiChip, mdiDesktopTowerMonitor, mdiMonitor, mdiNetwork, mdiPrinter, mdiRouterNetwork, mdiServerNetwork, mdiTelevisionClassic } from "@mdi/js";
import Icon from "@mdi/react";
import { NetworkLanDeviceTypeDTO } from "@webip/shared/src/dto/appliance"

export const IconeTipoDispositivoLan = ({ tipo, cor }: { tipo: NetworkLanDeviceTypeDTO, cor?: string }) => {
    const typeToIcon: Record<NetworkLanDeviceTypeDTO, React.ReactNode> = {
        'pc': <Icon path={mdiDesktopTowerMonitor} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
        'router': <Icon path={mdiRouterNetwork} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
        'servidor': <Icon path={mdiServerNetwork} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
        'impressora': <Icon path={mdiPrinter} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
        'tv': <Icon path={mdiMonitor} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
        'iot': <Icon path={mdiChip} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
        'outro': <Icon path={mdiNetwork} size="20px" color={cor || "var(--tc-color-gray-500)"} />,
    }
    return typeToIcon[tipo ?? 'outro'] || null;
}